import React, {useState} from 'react';


const SideMenu = (props) => {
    const { menuObj, childItems, navigateToLink } = props
    
    const [menuVisible, setMenuVisible] = useState(false)
    
    return (
        <li>
            <button type="button" className="p-link" onClick={()=>{setMenuVisible(!menuVisible)}}>
                <div className="menu-icon"><i className={`menubar-icon ${menuObj.menuIcon}`}></i></div>
                <span>{ menuObj.name }</span><i className="menu-toggle-icon pi pi-angle-down"></i>
            </button>
            <div className={`overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out ${menuVisible ? '' : 'hidden'}`}>
                <ol>
                    {
                        childItems.map(child => {
                            return <li key={child.menuId}><a className="" onClick={() => navigateToLink(child.clientPath)}>{ child.name }</a></li>
                        })
                    }
                </ol>
            </div>
        </li>
    );
};

export default SideMenu;
